import { toJS } from 'mobx';
import { downloadFilledTemplate } from './UkPdfTemplate';

const SCOPE_AND_SIGNING_CHECKBOXES = [
  'scopeAgree',
  'scopeDDR',
  'scopeKYB',
  'scopeAccount',
  'scopePay',
  'scopeCompliance',
  'scopeOther',
  'signAny',
  'signJoint',
];

const MAX_BENEFICIAL_OWNERS = 4;

export const findStepData = (mainStore, key) => {
  const stepIndex = mainStore.formDataList.findIndex((stepData) => stepData && toJS(stepData)[key] !== undefined);

  return { stepIndex, data: stepIndex >= 0 ? toJS(mainStore.formDataList[stepIndex]) : {} };
};

export const isListedPerson = (person = {}) =>
  Boolean(person.own25Checkbox || person.boardMemberCheckbox || person.significantControlCheckbox);

export const isBeneficialOwner = (person = {}) => Boolean(person.own25Checkbox || person.significantControlCheckbox);

const ownershipNature = (person) =>
  [
    person.own25Checkbox && '25%+ ownership',
    person.boardMemberCheckbox && 'board member / director',
    person.significantControlCheckbox && 'significant management control',
  ]
    .filter(Boolean)
    .join(' & ');

const formatBirthDate = (value) => {
  const isoDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
  return isoDate ? `${isoDate[3]}/${isoDate[2]}/${isoDate[1]}` : value;
};

export const downloadLetterOfAuthority = (mainStore, contactIndex = 0) => {
  const companyInfo = mainStore.creditApplicationDomain;
  const mainContact = findStepData(mainStore, 'mainContacts').data.mainContacts?.[contactIndex] || {};

  return downloadFilledTemplate({
    templateName: 'uk-letter-of-authority',
    fileName: `ezyCollect_UK_Letter_of_Authority_${companyInfo.businessNumber || 'draft'}.pdf`,
    fill: ({ setText, uncheck }) => {
      setText('legalName', companyInfo.registeredCompanyName);
      setText('bizNum', companyInfo.businessNumber);
      setText('authName0', mainContact.fullName);
      setText('authPos0', mainContact.position);
      setText('authEmail0', mainContact.email);
      uncheck(SCOPE_AND_SIGNING_CHECKBOXES);
    },
  });
};

export const downloadUboDeclaration = (mainStore) => {
  const companyInfo = mainStore.creditApplicationDomain;
  const owners = (findStepData(mainStore, 'directorsOrOwners').data.directorsOrOwners || [])
    .filter(isListedPerson)
    .slice(0, MAX_BENEFICIAL_OWNERS);
  const signatory = findStepData(mainStore, 'mainContacts').data.mainContacts?.[0] || {};

  return downloadFilledTemplate({
    templateName: 'uk-ubo-declaration',
    fileName: `ezyCollect_UK_UBO_Declaration_${companyInfo.businessNumber || 'draft'}.pdf`,
    fill: ({ setText }) => {
      setText('legalName', companyInfo.registeredCompanyName);
      setText('bizNum', companyInfo.businessNumber);
      owners.forEach((person, index) => {
        const address = [person.streetAddressOne, person.streetAddressTwo, person.city, person.state, person.postCode]
          .filter(Boolean)
          .join(', ');

        setText(`uboName${index}`, [person.firstName, person.lastName].filter(Boolean).join(' '));
        setText(`uboDob${index}`, formatBirthDate(person.birthDate));
        setText(`uboPct${index}`, person.ownership ? `${person.ownership}%` : '');
        setText(`uboAddr${index}`, [address, ownershipNature(person)].filter(Boolean).join(' - '));
      });
      setText('sigName', [signatory.fullName, signatory.position].filter(Boolean).join(', '));
    },
  });
};
